import * as THREE from 'three';

export default class HullComponent {

  setColor(color){
    if (color){
      for (let i = 0; i < this.group.children.length; i++) {
        const child = this.group.children[i];
        if(child.material){
          child.material.color.set(color);
        }
      }
    }
  }

  setEmissive(color){
    if (color){
      for (let i = 0; i < this.group.children.length; i++) {
        const child = this.group.children[i];
        if(child.material){
          child.material.emissive.set(color);
        }
      }
    }
  }
    
  calculateUVs(geometry){
    geometry.computeVertexNormals(); // Needed for shading
    geometry.computeBoundingBox(); // Ensure bounding box exists

    const bbox = geometry.boundingBox;
    const min = bbox.min || 0;
    const max = bbox.max || 1;

    const offset = new THREE.Vector2(-min.x, -min.y);
    const range = new THREE.Vector2(max.x - min.x, max.y - min.y);

    const positions = geometry.attributes.position.array;
    // console.log(positions);
    const uvs = new Float32Array((positions.length / 3) * 2); // 2 UV values per vertex
    
    for (let i = 0, j = 0; i < positions.length; i += 3, j += 2) {
        let x = positions[i];
        let y = positions[i + 1];

        // Normalize to [0,1] using bounding box
        uvs[j] = (x + offset.x) / range.x; // U coordinate
        uvs[j + 1] = (y + offset.y) / range.y; // V coordinate
    }
    // console.log(uvs);
    // Assign UVs to BufferGeometry
    geometry.setAttribute('uv', new THREE.BufferAttribute(uvs, 2));
    geometry.uvsNeedUpdate = true;
  }

  // Lathe UVs run 0->1 with the winding direction. On a mirrored lathe
  // (negated phiStart / rotation / skew) the mirror-partner vertex ends up with
  // u mirrored as well, so the skin reads flipped rather than mirrored.
  // Flipping u here restores true mirror symmetry; v is unaffected because it
  // only depends on the profile index, which the mirror leaves in place.
  mirrorU(geometry){
    const uv = geometry.attributes.uv;
    if (!uv) {
      return;
    }
    for (let i = 0; i < uv.count; i++) {
      uv.setX(i, 1.0 - uv.getX(i));
    }
    uv.needsUpdate = true;
  }
}